export default {
  common: {
    regionZone: "区域/国家",
    seller: "销售人员",
    chillerOrPlant: "目标",
    dateRange: "查询时间段",
    showNumber: "显示数字标注",
    hallOfFame: "排行榜",
    statisticChart: "统计图",
    win: "已赢得的项目",
    pipeline: "进行中项目",

    chillerAndChillerPlant: "冷机和冷站",
    chiller: "冷机",
    chillerPlant: "冷站",
    heating: "制热",

    ChillerRetrofit: "冷机改造",
    ChillerPlantRetrofit: "冷站改造",
    HeatingElectricRetrofit: "锅炉改热泵",

    regions: "区域",
    zones: "国家",

    resetPipelineCheckMesg: "系统即将使用当前的在跟项目数据替换上个月的快照数据，此项操作不可逆，你是否确认执行该操作 ？",
    resetPipeline: "重设在跟项目数据",
    resetLastMonthPipelinedata: "重设上月在跟项目数据",
    verificationCode: "验证码",

    enterVerificationCode: "请输入验证码来确认操作",
    verificationCodeError: "验证码错误",

    note: "请注意",
    dataBefore202601: "2026年1月及之前的数据来自与1.0版本，暂时不支持对 ‘项目状态’ 和 '项目目标' 的条件查询。",
    iKnowThis: "关闭",
    availableWhen202602: "仅适用于2026年2月及之后的日期区间"
  }
}



// WEBPACK FOOTER //
// ./src/locale/dashboard/zh.js